let globalSheets: CSSStyleSheet[] | null = null;

export function getGlobalStyleSheets() {
  if (globalSheets === null) {
    globalSheets = Array.from(document.styleSheets).map((x) => {
      const sheet = new CSSStyleSheet();
      const css = Array.from(x.cssRules)
        .map((rule) => rule.cssText)
        .join(" ");
      sheet.replaceSync(css);
      return sheet;
    });
  }
  return globalSheets;
}

export function copyCssSource(
  sourceMaps: { source: string; target: string }[]
): string {
  const newRules: string[] = [];
  const styleSheets = Array.from(document.styleSheets);

  const valuesToMap = [...sourceMaps];
  styleSheets.forEach((styleSheet) => {
    try {
      const cssRules = Array.from(styleSheet.cssRules);
      cssRules.forEach((rule) => {
        if (valuesToMap.length === 0) return;

        if (rule instanceof CSSStyleRule) {
          const valueToMap = valuesToMap.find(
            (sourceMap) => sourceMap.source === rule.selectorText
          );
          if (valueToMap) {
            const styles: string[] = [];
            for (let i = 0; i < rule.style.length; i++) {
              const propertyName = rule.style[i];
              const propertyValue = rule.style.getPropertyValue(propertyName);
              styles.push(`${propertyName}: ${propertyValue}`);
            }
            newRules.push(`${valueToMap.target} { ${styles.join("; ")} }`);

            valuesToMap.splice(valuesToMap.indexOf(valueToMap), 1);
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  });
  return newRules.join(" ");
}

export function findCssRules(query: string): string {
  const matchingRules: CSSStyleRule[] = [];
  const styleSheets = Array.from(document.styleSheets);

  const newRules: string[] = [];
  styleSheets.forEach((styleSheet) => {
    try {
      const cssRules = Array.from(styleSheet.cssRules);
      cssRules.forEach((rule) => {
        if (rule instanceof CSSStyleRule && rule.selectorText.includes(query)) {
          matchingRules.push(rule);
        }
      });
    } catch (e) {
      console.error(e);
    }
  });

  matchingRules.forEach((rule) => {
    const newSelector = rule.selectorText.substring(
      rule.selectorText.indexOf(query)
    );
    const styles: string[] = [];
    for (let i = 0; i < rule.style.length; i++) {
      const propertyName = rule.style[i];
      const propertyValue = rule.style.getPropertyValue(propertyName);
      styles.push(`${propertyName}: ${propertyValue}`);
    }
    newRules.push(`${newSelector} { ${styles.join("; ")} }`);
  });
  return newRules.join(" ");
}
